namespace Gamification.Gamification {
    export interface ProdottiEsperienzeRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoEsperienza?: number;
        IdProdotto?: number;
        IdentifierEsperienza?: string;
        Nome?: string;
        Descrizione?: string;
        IdentifierPunteggioEsperienza?: string;
        PunteggioNome?: string;
        PunteggioValoreIniziale?: number;
        PunteggioValoreNegativo?: number;
        InfluenzaPunteggioGlobale?: number;
        Bozza?: number;
        NumeroClassi?: number;
        EsperienzaClassiList?: ProdottiEsperienzeClassiRow[];
    }

    export namespace ProdottiEsperienzeRow {
        export const idProperty = 'IdProdottoEsperienza';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiEsperienze';
        export const lookupKey = 'Gamification.ProdottiEsperienze';

        export function getLookup(): Q.Lookup<ProdottiEsperienzeRow> {
            return Q.getLookup<ProdottiEsperienzeRow>('Gamification.ProdottiEsperienze');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            IdProdotto = "IdProdotto",
            IdentifierEsperienza = "IdentifierEsperienza",
            Nome = "Nome",
            Descrizione = "Descrizione",
            IdentifierPunteggioEsperienza = "IdentifierPunteggioEsperienza",
            PunteggioNome = "PunteggioNome",
            PunteggioValoreIniziale = "PunteggioValoreIniziale",
            PunteggioValoreNegativo = "PunteggioValoreNegativo",
            InfluenzaPunteggioGlobale = "InfluenzaPunteggioGlobale",
            Bozza = "Bozza",
            NumeroClassi = "NumeroClassi",
            EsperienzaClassiList = "EsperienzaClassiList"
        }
    }
}
